import { z } from 'zod';
import { nonNegativeNumber, requiredUuidString } from '../zod-helpers/index.js';
import { PRODUCT_CONSTRAINTS } from './constraints.js';
export const createProductInputSchema = z.object({
    num: z
        .string()
        .trim()
        .min(1, `${PRODUCT_CONSTRAINTS.num.label} is required.`)
        .max(PRODUCT_CONSTRAINTS.num.maxLength),
    brandId: requiredUuidString('Brand is required.', 'Invalid brand selection.'),
    uomId: requiredUuidString('UOM is required.', 'Invalid UOM selection.'),
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    name: z.string().trim().max(PRODUCT_CONSTRAINTS.name.maxLength).optional().nullable(),
    description: z
        .string()
        .trim()
        .max(PRODUCT_CONSTRAINTS.description.maxLength)
        .optional()
        .nullable(),
    price: nonNegativeNumber('Product price').optional().nullable(),
    sku: z.string().max(PRODUCT_CONSTRAINTS.sku.maxLength).optional().nullable(),
    upc: z.string().max(PRODUCT_CONSTRAINTS.upc.maxLength).optional().nullable(),
});
//# sourceMappingURL=create-input.js.map